module.exports = {
	"version": "2.14.0",
	"supportedLanguages": [
		"en",
		"cs",
		"da",
		"de",
		"el",
		"es",
		"fi",
		"fr",
		"hu",
		"id",
		"in",
		"it",
		"ja",
		"ko",
		"ms",
		"nb",
		"nl-NL",
		"pl",
		"pt-BR",
		"ro",
		"ru",
		"sv",
		"th",
		"tr",
		"uk",
		"zh-CN",
		"zh-TW"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./target/js/config/config.json
 ** module id = 329
 ** module chunks = 0
 **/